// extracted by mini-css-extract-plugin
export default {"header":"oRv38","statistics":"tIjYE"};